module.exports = __webpack_public_path__ + "media/images/sp/top/recommend-plan-text-wedding2-3092d2b9090c3c5022e932d3f446418b.png";